import { getMakeAPI, Method, getFullUrl, getGetchServiceConfig, mergeConfig } from '@golden/getch';
import { GLOBAL_VERSION } from '../constants';
const makeAPI = getMakeAPI('v1');
export const QRCODE_API = {
    GET_QRCODE: makeAPI(Method.GET, 'qrcode')()
};
export function createQRCodeService(api) {
    return {
        generateURL(content, size) {
            return getFullUrl(mergeConfig(api.base.getDefaultConfig(), getGetchServiceConfig(api.base, QRCODE_API.GET_QRCODE, GLOBAL_VERSION, { data: { size, content } })));
        }
    };
}
//# sourceMappingURL=QRCodeService.js.map